import { actionTypes as bookmakersInfoActionTypes } from './bookmakersInfo.actions';

function removeUserName(bookmaker) {
    const newBookmaker = { ...bookmaker };
    delete newBookmaker.username;
    return newBookmaker;
}

const updateBookmaker = (bookmaker = {}, action) => {
    switch (action.type) {
        case bookmakersInfoActionTypes.TOGGLE_BALANCE_VISIBILITY:
            return {
                ...bookmaker,
                showBalance: !(bookmaker.showBalance !== false),
            };
        case bookmakersInfoActionTypes.SAVE_USERNAME:
            return {
                ...bookmaker,
                username: action.username,
            };
        case bookmakersInfoActionTypes.REMOVE_USERNAME:
            return removeUserName(bookmaker);
        default:
            return bookmaker;
    }
};

export default updateBookmaker;



// WEBPACK FOOTER //
// /src/js/common/bookmakersInfo/updateBookmaker.reducer.js